var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item.type === "group"
    ? _c(
        "div",
        {
          key: _vm.item.key,
          class: {
            [_vm.$style.grouper]: _vm.previewMode,
            [_vm.$style.editModeGrouper]: !_vm.previewMode,
          },
        },
        [
          !_vm.previewMode
            ? _c("bulk-check-box", {
                attrs: {
                  ids: _vm.item.ids,
                  view: _vm.view,
                  "updating-list": _vm.updatingList,
                },
                on: {
                  toggle: function ($event) {
                    return _vm.$emit("toggle-bulk", $event)
                  },
                },
              })
            : _vm._e(),
          _vm.groupBy === "rating"
            ? _c("rb-rating", {
                attrs: { rate: (_vm.item.key || "").toUpperCase() },
              })
            : _c("span", [_vm._v(_vm._s(_vm.item.key || "__"))]),
        ],
        1
      )
    : _c("hotel", {
        key: _vm.item.id,
        attrs: {
          hotel: _vm.item,
          view: _vm.view,
          previewing: _vm.previewMode,
          updating: _vm.updatingList.includes(_vm.item.bidId),
        },
        on: {
          toggle: function ($event) {
            return _vm.$emit("toggle", _vm.item)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }